import React, { useMemo } from 'react';
import { GoogleMap, MarkerF, useLoadScript } from "@react-google-maps/api";
import {useEffect, useState} from "react";
import ContactForm from "./ContactForm";

function Kontakt() {
    const [windowDimension, setWindowDimension] = useState(null);

    useEffect(() => {
        setWindowDimension(window.innerWidth);
    }, []);

    useEffect(() => {
        function handleResize() {
            setWindowDimension(window.innerWidth);
        }

        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);

    const isMobile = windowDimension <= 640;
    document.title = "Kontakt"
    const { isLoaded } = useLoadScript({
        googleMapsApiKey: process.env.REACT_APP_GOOGLE_API_KEY || "AIzaSyBVOia7rUmD0s5rjEWHQjs53Tqs5SNyubY",
    });
    const center = useMemo(() => ({ lat: 49.8171971103634, lng: 9.035827213852667, }), []);

    return (
        <div>
            {isMobile ? (
                <div>
                    <div className={"übertitelmobile"}><h3>Kontakt</h3></div>
                    <div className={"kontaktAdresseMobile"}>
                        <div className={"kontaktAdresseTitelMobile"}>Adresse</div>
                        <div>Logopädische Praxis<br/>
                            Sandra Duffy-Heusel<br/>
                            Geisrain 1<br/>
                            64747 Breuberg</div>
                        <div style={{marginTop:"6px"}}>Tel. <a href="tel:+4961653637" style={{color:"#7e2b2b"}}>06165/3637</a><br/>
                            <a href="mailto:info@logopaedie-breuberg.de" style={{color:"#7e2b2b"}}>info@logopaedie-breuberg.de</a></div>
                    </div>
                    <div className={"übertitelmobile"} style={{marginTop:"20px", marginBottom:"6px", paddingBottom:"0"}}><h3 style={{margin:"0"}}>Anmeldeformular</h3></div>
                    <ContactForm isMobile={true} />
                    <div style={{height: "400px",
                        width: "70%",paddingLeft:"8%",paddingTop:"30px"}}>
                        {!isLoaded ? (
                            <h1>Loading...</h1>
                        ) : (
                            <GoogleMap
                                mapContainerStyle={{ height: "60%",
                                    width: "120%"}}
                                center={center}
                                zoom={18}
                            >
                                <MarkerF position={{ lat: 49.81718444824219, lng: 9.035828590393066 }} />
                            </GoogleMap>
                        )}
                    </div>
                </div>
            ) : (
                <div>
            <div className={"übertitel"}><h3>Kontakt</h3></div>
            <div className={"kontaktAdresse"}>
                <div className={"kontaktAdresseTitel"}>Adresse</div>
                <div>Logopädische Praxis<br/>
                    Sandra Duffy-Heusel<br/>
                    Geisrain 1<br/>
                    64747 Breuberg</div>
                <div style={{marginTop:"8px"}}>Tel. <a href="tel:+4961653637" style={{color:"#7e2b2b"}}>06165/3637</a><br/>
                    <a href="mailto:info@logopaedie-breuberg.de" style={{color:"#7e2b2b"}}>info@logopaedie-breuberg.de</a></div>
            </div>
            <div style={{textAlign:"center", marginTop:"40px", marginBottom:"6px"}}><h3 style={{margin:"0"}}>Anmeldeformular</h3></div>
            <ContactForm isMobile={false} />
            <div style={{height: "600px",
                width: "70%",paddingLeft:"21%", paddingTop: "5%"}}>
                {!isLoaded ? (
                    <h1>Loading...</h1>
                ) : (
                    <GoogleMap
                        mapContainerStyle={{ height: "550px",
                            width: "850px"}}
                        center={center}
                        zoom={18}
                    >
                        <MarkerF position={{ lat: 49.81718444824219, lng: 9.035828590393066 }} />
                    </GoogleMap>
                )}
            </div>
        </div>
            )}
        </div>
    )
}

export default Kontakt;